import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const PageLayout = ({
  children,
  className,
  useDeprecatedPageWidth = false,
  width = 'medium',
  style = {},
  horizontalPadding = false,
}) => {
  const widthName = useDeprecatedPageWidth ? 'small' : width
  return (
    <div
      style={style}
      className={cx(
        'base',
        widthName,
        { 'horizontal-padding': horizontalPadding },
        className
      )}
      data-page-width={widthName}
    >
      {children}
    </div>
  )
}

PageLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  useDeprecatedPageWidth: PropTypes.bool,
  width: PropTypes.oneOf(['small', 'medium', 'large']),
  style: PropTypes.object,
  horizontalPadding: PropTypes.bool,
}

export default PageLayout
